module.exports = __webpack_public_path__ + "static/media/workingmemory-words-11.61a7d824.mp3";